import React, { useCallback, memo } from 'react';
import styled from 'styled-components';
import { STATUSES } from '../TicketStatus/constants';
import { formatDecimal, pluralize } from '../../../../utils/userflow';
import { GeneralManagerType } from 'types/types';
import { FILTER_NAMES } from '../TicketFilters/constants';

const ticketPluralize = ['тикет требует', 'тикета требуют', 'тикетов требуют'];

interface ITicketListAttention {
  className?: string;
  count: number;
  currentManager: GeneralManagerType;
  onFilter: (filters: { [key: string]: string[] }) => void;
}

const TicketListAttention = ({
  count,
  currentManager,
  onFilter,
  ...restProps
}: ITicketListAttention) => {
  const handleFilter = useCallback(() => {
    onFilter({
      [FILTER_NAMES.STATUSES]: [STATUSES.WAIT_FOR_SERVICE],
      [FILTER_NAMES.MANAGERS]: [currentManager.id],
    });
  }, [onFilter]);

  return (
    <StyledButton onClick={handleFilter} {...restProps}>
      {`${formatDecimal(count)} ${pluralize(count, ticketPluralize)} действия`}
    </StyledButton>
  );
};

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #17181a;
  font-size: 12px;
  line-height: 16px;
  padding: 3px 0;
  margin: 0 10px 8px 0;
  background-color: #fffbe5;
  border-radius: 4px;
  border: none;
  outline: none;
  cursor: pointer;
`;

export default memo(TicketListAttention);
